import React, { useState, useEffect } from 'react'
import { getData } from '../../helpers/api';
import moment from 'moment';
import { useNavigate, useLocation } from 'react-router-dom'
import { EditorState } from 'draft-js';

import {
    CBadge,
    CButton,
    CButtonGroup,
    CCard,
    CCardBody,
    CCardFooter,
    CCardHeader,
    CCol,
    CProgress,
    CRow,
    CCallout
} from 'compat/coreui'

export default function Messages(props) {
    const [orderData, setOrderData] = useState([])

    const navigate = useNavigate();
    const [userData, setUserData] = useState({})
    const [editorState, setEditorState] = useState(EditorState.createEmpty());
    const [showHours, setShowHours] = useState(false);
    const [businessName, setBusinessName] = useState("");
    const [businessType, setBusinessType] = useState("");
    const [businessEmail, setBusinessEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [webUrl, setWebUrl] = useState("");
    const [address, setAddress] = useState("");
    const [address2, setAddress2] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [operationTime, setOperationTime] = useState("");
    const [pincode, setPincode] = useState("");
    const [fax, setFax] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [alternatePhone, setAlternatePhone] = useState("");
    const [alternateEmail, setAlternateEmail] = useState("");
    const [img, setImage] = useState("");
    const [headline, setHeadline] = useState("");
    const [locationState, setLocationState] = useState("");

    useEffect(() => {
        getOrders()
    }, [])

    const getOrders = () => {
        getData(`${process.env.REACT_APP_APP_API_URL}/api/order`).then(res => {
            console.log(res)
            setOrderData(res.data.orders);
        }).catch(e => console.log(e))
    }

    const setPic = (selectedImg) => {
        console.log("Image---->>> ", selectedImg);
        setImage(URL.createObjectURL(selectedImg))
    }
    getData(`${process.env.REACT_APP_APP_API_URL}/api/user`).then(res => {
        setPincode(res.data.user.zip_code)
        setAddress(res.data.user.address1)
        setCity(res.data.user.city)
        setState(res.data.user.state)
        if (res.data.user.state == "SELLER") {
            setHeadline("Business Information")
            setLocationState(false)
        } else {
            setHeadline("Profile Information")
            setLocationState(true)
        }
    }).catch(console.log)
    return (
        <>
            <span className="c_8 user_inbox"><h1 className="title">My Inbox</h1><form method="post" action="/profile_user.php?show=message&action=bulk" id="bulk_form">
                <input type="hidden" name="mark_all" id="mark_all" defaultValue />
                <span className="messaging c_4">
                    <span className="nifty_heading" style={{ height: "40px" }}>
                        <span className="title">
                            <span className="icon-envelop icon" /> Messaging
                        </span>
                        <span style={{ marginTop: "50px" }} className="navigation" >
                            <ul>
                                <li><a href="/message/inbox/" className="active">Inbox</a></li>
                                <li><a href="/message/sent/">Outbox</a></li>
                            </ul>
                        </span>
                        <span style={{ marginTop: "50px" }} className="navigation">
                            <ul>
                                <li><a href="/message/new/" className="add"><span className="icon-plus-circle-2 icon" /> Compose</a></li>
                            </ul>
                        </span>
                    </span>
                    <span className="action_bar">
                        <span className="mark" id="mark_all_container">
                            Mark As: <a href="#">Read</a> | <a href="#">Unread</a> |  <a href="#">Deleted</a>
                        </span>
                        <span className="count">Showing Messages 1 - 25</span>
                    </span>
                    <div className="message_nav c_4">
                        <select name="messages_filter" id="messages_filter" style={{ float: 'right', fontSize: 12, padding: 3, margin: 4, display: 'inline', maxWidth: 275 }} onchange="window.location='/message/inbox/?listing_id=' + $(this).val();"><option value>All Mailboxes (0)</option>
                        </select>	</div>
                    <div className="clear" />
                    <p style={{ width: '100%', padding: 15, textAlign: 'center' }}>No messages were found!</p><br /></span></form></span>

        </>
    )
}